import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import {
  getAllCategoryList,
  getSearchProducts,
} from "../../reducers/adminReducers";

import AddBoxForm from "./addBoxForm.js";
import { queryString } from "../../utils/queryString";
import { adminInstance } from "../../config/axios";
import { useSelector, useDispatch } from "react-redux";
import {
  analyzeManualBoxData,
  // boxPriceCalculation,
} from "../../utils/multiuseFunctions";

const AddBox = () => {
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);

  const { id } = queryString();
  const selectedOption = [];
  const selectedProductOption = [];
  const {
    selectedCategory,
    productList,
    selectedRarity,
    pageCounts,
    selectedBoxCategory,
    allspecialTagList,
    boxLatestColor,
    adminSetting,
  } = result || {};
  const { boxProfit: profitMarginBox } = adminSetting || {};
  const initialObj = {
    name: "",
    image: "",
    price: "",
    description: "",
    profitMargin: "",
    category: [],
    setCategory: [],
    hideBox: true,
    enableBox: false,
    jackpotEnabled: false,
    jackpotTrigger: "",
    jackpotCounter: 0,
  };
  const serchInitialObj = {
    title: "",
    min: "",
    max: "",
    category: "",
    rarity: "",
    brandId: "",
    partnerId: "",
    skip: 0,
    limit: 12,
  };

  const [chooseProduct, setChooseProduct] = useState([]);
  const [payload, setPayload] = useState(initialObj);
  const [searchPayload, setSeachPayload] = useState(serchInitialObj);
  const [selectedProductList, setSelectedProductList] = useState([]);
  const [bxPrice, setBoxPrice] = useState("0.00");
  const [totalOdds, settotalOdds] = useState(0);
  const [remainOdds, setRemainOdds] = useState(0);
  const [allTagList, setAllTagList] = useState([]);
  const [cerrors, setCerrors] = useState("");
  const [boxProfit, setBoxProfit] = useState();
  const [allLatestBoxColor, setAllLatestBoxColor] = useState([]);
  const [profit, setProfit] = useState(0);
  //const [defaultProfitMargin, setDefaultProfitMargin] = useState('');
  const limit = 12;
  useEffect(() => {
    if (profitMarginBox) {
      setPayload({ ...payload, boxProfit: profitMarginBox });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profitMarginBox]);
  const getSingleBoxData = async (id) => {
    try {
      const response = await adminInstance().get(
        `api/admin/getBoxDetailById/${id}`
      );
      const { code, boxData, boxItems, choseProducts } = response.data;
      const { category, price } = boxData || {};
      if (code === 200) {
        let filter1 = selectedBoxCategory.filter((item) =>
          category.includes(item.value)
        );
        const filtered = boxItems.filter(function (el) {
          return el != null;
        });
        let copyPayload = boxData;
        copyPayload.setCategory = filter1;
        setChooseProduct(choseProducts);
        console.log("choseProducts", choseProducts);
        const { boxPrice, profit, totalOdds, remainingOdds } =
          analyzeManualBoxData(price, choseProducts);
        setPayload({ ...payload, boxPrice: boxPrice });
        setBoxPrice(boxPrice);
        settotalOdds(totalOdds);
        setRemainOdds(remainingOdds);
        setProfit(profit);
        copyPayload.boxPrice = boxPrice;
        setSelectedProductList(filtered);
        setPayload(copyPayload);
      }
    } catch (error) {
      console.log("There is an error occured", error);
    }
  };
  const handleSearchProduct = async (e) => {
    const { value, name } = e.target;
    const copySearchPayLoad = { ...searchPayload };
    copySearchPayLoad[name] = value;
    copySearchPayLoad.skip = 0;
    setSeachPayload(copySearchPayLoad);
    dispatch(getSearchProducts(copySearchPayLoad));
  };
  const pageCount = Math.ceil(pageCounts / limit);
  const handlePageClick = ({ selected }) => {
    const copySearchPayLoad = { ...searchPayload };
    copySearchPayLoad.skip = selected * limit;
    setSeachPayload(copySearchPayLoad);
    dispatch(getSearchProducts(copySearchPayLoad));
  };
  const getPreviousBox = async () => {
    try {
      const response = await adminInstance().get("api/admin/getPreviousBox");
      const { getPrevious } = response.data;
      const { specialTag, color } = getPrevious || {};
      let copyPayLoad = { ...payload };
      copyPayLoad.specialTag = specialTag;
      copyPayLoad.color = color;
      setPayload(copyPayLoad);
    } catch (error) {}
  };
  useEffect(() => {
    dispatch(getAllCategoryList());
    if (id) {
      getSingleBoxData(id);
    } else {
      setBoxProfit(adminSetting?.boxProfit);
      getPreviousBox();
    }
    // const [boxProfit, setBoxProfit] = useState();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminSetting]);

  useEffect(() => {
    dispatch(getSearchProducts(searchPayload));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAllTagList(allspecialTagList);
  }, [allspecialTagList]);
  useEffect(() => {
    setAllLatestBoxColor(boxLatestColor);
  }, [boxLatestColor]);
  const handleProduct = (val, id, checkselected) => {
    if (checkselected) {
      return;
    }
    let chooseProductArray = [...chooseProduct];
    let copyArray = [...selectedProductList];
    const obj = {
      chance: 0,
      pid: id,
      sellPrice: val.sellPrice,
      purchasePrice: val.purchasePrice,
      isJackpot: false,
    };
    copyArray.push(val);
    chooseProductArray.push(obj);
    chooseProductArray.sort(
      (a, b) => parseFloat(b.productPrice) - parseFloat(a.productPrice)
    );
    copyArray.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
    setSelectedProductList(copyArray);
    setChooseProduct(chooseProductArray);
  };

  const handleOnchangePro = async (e, index) => {
    const { name, value } = e || {};
    let copychooseProduct = [...chooseProduct];
    copychooseProduct[index][name] = value;
    const { boxPrice, profit, totalOdds, remainingOdds } = analyzeManualBoxData(
      payload?.boxPrice,
      copychooseProduct
    );
    setPayload({ ...payload, boxPrice: boxPrice });
    setBoxPrice(boxPrice);
    settotalOdds(totalOdds);
    setRemainOdds(remainingOdds);
    setProfit(profit);
    setChooseProduct(copychooseProduct);
  };
  const handleRemove = async (index) => {
    let chooseProductArray = [...chooseProduct];
    let copyArray = [...selectedProductList];
    chooseProductArray.splice(index, 1);
    copyArray.splice(index, 1);
    const { boxPrice, profit, totalOdds, remainingOdds } = analyzeManualBoxData(
      payload?.boxPrice,
      chooseProductArray
    );
    setPayload({ ...payload, boxPrice: boxPrice });
    setBoxPrice(boxPrice);
    settotalOdds(totalOdds);
    setRemainOdds(remainingOdds);
    setProfit(profit);
    setSelectedProductList(copyArray);
    setChooseProduct(chooseProductArray);
  };
  const handleSelectChange = (Opt, name, modify) => {
    let newPayload = { ...payload };
    const datas = modify
      ? Array.isArray(Opt)
        ? Opt.map((x) => x.value)
        : []
      : Opt;
    newPayload[name] = datas;
    setPayload(newPayload);
    if (datas.length > 0) {
      setCerrors("");
    } else {
      setCerrors("This field is required");
    }
  };
  // Featured Case handle chnage function

  const handleBoxQuantity = (e) => {
    const { name, value } = e.target;
    let newPayload = { ...payload };
    newPayload[name] = value;
    setPayload(newPayload);
  };
  const handleBoxTimer = (e) => {
    const { name, value } = e.target;
    let newPayload = { ...payload };
    newPayload[name] = value;
    setPayload(newPayload);
  };
  const handleOnChangeVisible = (e, p) => {
    const { name } = e.target;
    let newPayload = { ...payload };
    newPayload[name] = p;
    setPayload(newPayload);
  };

  const handleBoxAmount = async (e) => {
    const value = e.target.value;
    const regex = /^\d*\.?\d*$/;
    if (regex.test(value)) {
      setPayload({ ...payload, boxPrice: value });
    }
    let chooseProductArray = [...chooseProduct];
    const { boxPrice, profit, totalOdds, remainingOdds } = analyzeManualBoxData(
      value,
      chooseProductArray
    );
    setBoxPrice(boxPrice);
    settotalOdds(totalOdds);
    setRemainOdds(remainingOdds);
    setProfit(profit);
  };

  const handleJackpotSettingsChange = (e) => {
    const { name, value, type, checked } = e.target;
    const nextValue = type === "checkbox" ? checked : value;
    setPayload((prev) => ({
      ...prev,
      [name]: nextValue,
    }));
  };

  const handleJackpotItemSelect = (selectedPid) => {
    const updatedProducts = chooseProduct.map((item) => ({
      ...item,
      isJackpot: item.pid === selectedPid,
    }));

    const { boxPrice, profit, totalOdds, remainingOdds } = analyzeManualBoxData(
      payload?.boxPrice,
      updatedProducts
    );

    setChooseProduct(updatedProducts);
    setPayload((prev) => ({ ...prev, boxPrice }));
    setBoxPrice(boxPrice);
    settotalOdds(totalOdds);
    setRemainOdds(remainingOdds);
    setProfit(profit);
  };

  const handleResetJackpotCounter = async () => {
    if (!payload?._id) return;
    try {
      const response = await adminInstance().put(
        `/api/admin/resetBoxJackpotCounter/${payload._id}`
      );
      const { code, jackpotCounter } = response.data || {};
      if (code === 200) {
        setPayload((prev) => ({ ...prev, jackpotCounter }));
      }
    } catch (error) {
      console.log("There is an error occured", error);
    }
  };

  return (
    <Fragment>
      <Breadcrumb title="Box" parent="Box" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card className="addbox-form">
              <CardHeader>
                <h5> Add Cases </h5>
              </CardHeader>
              <CardBody>
                {1 ? (
                  1 && (
                    <AddBoxForm
                      payload={payload}
                      selectedOption={selectedOption}
                      products={selectedProductList}
                      productList={productList}
                      categoryList={selectedCategory}
                      handleSearchProduct={handleSearchProduct}
                      selectedProductOption={selectedProductOption}
                      rarityList={selectedRarity}
                      handlePageClick={handlePageClick}
                      pageCount={pageCount}
                      handleProduct={handleProduct}
                      handleOnchangePro={handleOnchangePro}
                      chooseProduct={chooseProduct}
                      handleRemove={handleRemove}
                      boxCategoryList={selectedBoxCategory}
                      totalOdds={totalOdds}
                      boxProfit={boxProfit}
                      remainOdds={remainOdds}
                      allspecialTagList={allTagList}
                      boxLatestColor={allLatestBoxColor}
                      handleSelectChange={handleSelectChange}
                      setCerrors={setCerrors}
                      cerrors={cerrors}
                      handleBoxQuantity={handleBoxQuantity}
                      handleBoxTimer={handleBoxTimer}
                      handleOnChangeVisible={handleOnChangeVisible}
                      handleBoxAmount={handleBoxAmount}
                      handleJackpotSettingsChange={handleJackpotSettingsChange}
                      handleJackpotItemSelect={handleJackpotItemSelect}
                      handleResetJackpotCounter={handleResetJackpotCounter}
                      profit={profit}
                      boxPrice={bxPrice}
                    />
                  )
                ) : (
                  <>
                    {payload?.color && (
                      <AddBoxForm
                        payload={payload}
                        selectedOption={selectedOption}
                        products={selectedProductList}
                        productList={productList}
                        categoryList={selectedCategory}
                        handleSearchProduct={handleSearchProduct}
                        selectedProductOption={selectedProductOption}
                        rarityList={selectedRarity}
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                        handleProduct={handleProduct}
                        handleOnchangePro={handleOnchangePro}
                        chooseProduct={chooseProduct}
                        handleRemove={handleRemove}
                        boxCategoryList={selectedBoxCategory}
                        totalOdds={totalOdds}
                        boxProfit={boxProfit}
                        remainOdds={remainOdds}
                        allspecialTagList={allTagList}
                        boxLatestColor={allLatestBoxColor}
                        handleSelectChange={handleSelectChange}
                        setCerrors={setCerrors}
                        cerrors={cerrors}
                        handleBoxQuantity={handleBoxQuantity}
                        handleBoxTimer={handleBoxTimer}
                        handleOnChangeVisible={handleOnChangeVisible}
                        handleBoxAmount={handleBoxAmount}
                        handleJackpotSettingsChange={handleJackpotSettingsChange}
                        handleJackpotItemSelect={handleJackpotItemSelect}
                        handleResetJackpotCounter={handleResetJackpotCounter}
                        profit={profit}
                        boxPrice={bxPrice}
                      />
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AddBox;
